/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * ThemeToggle.tsx — Them\1 \2oggle (services/operator-web-app).
 */

import { useStore } from 'zustand';
import { themeStore } from '@/store/themeStore';
import { IconButton } from '@/components/ui/IconButton';
import { useTranslation } from '@/i18n';

const SunIcon = () => (
  <svg
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
);

const MoonIcon = () => (
  <svg
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden
  >
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
  </svg>
);

export function ThemeToggle() {
  const t = useTranslation();
  const theme = useStore(themeStore, (s) => s.theme);
  const toggleTheme = useStore(themeStore, (s) => s.toggleTheme);
  const isDark = theme === 'dark';

  return (
    <IconButton
      icon={isDark ? <SunIcon /> : <MoonIcon />}
      variant="ghost"
      size="sm"
      aria-label={isDark ? t('theme.enable_light') : t('theme.enable_dark')}
      onClick={toggleTheme}
    />
  );
}
